import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import useWelcomeSearch, {
  numberWidget,
  messagesTodayLink,
  alertsOrEventsLink
} from "components/welcome/hooks/useWelcomeSearch";
import useMetricsTimeRange from "components/welcome/hooks/useMetricsTimeRange";
import usePermittedAlertsEventsStreams from "components/welcome/hooks/usePermittedAlertsEventsStreams";
import WidgetPosition from "views/logic/widgets/WidgetPosition";
import { KPI_WIDGET_GRID_HEIGHT } from "../Constants";
const buildEntries = (timeRange, permittedAlertsEventsStreams, t) => {
  const messages = numberWidget({ title: t("welcome_metrics.messages_today"), timeRange, link: messagesTodayLink(timeRange) });
  if (permittedAlertsEventsStreams.length === 0) {
    return [{ ...messages, position: new WidgetPosition(1, 1, KPI_WIDGET_GRID_HEIGHT, 12) }];
  }
  return [
    { ...messages, position: new WidgetPosition(1, 1, KPI_WIDGET_GRID_HEIGHT, 6) },
    {
      ...numberWidget({
        title: t("welcome_metrics.total_alerts"),
        timeRange,
        link: alertsOrEventsLink(timeRange, true),
        queryString: "alert:true",
        streams: permittedAlertsEventsStreams
      }),
      position: new WidgetPosition(7, 1, KPI_WIDGET_GRID_HEIGHT, 6)
    }
  ];
};
const useSecurityKpisSearch = () => {
  const { t } = useTranslation("enterprise_security_app");
  const rangeSeconds = useMetricsTimeRange();
  const permittedAlertsEventsStreams = usePermittedAlertsEventsStreams();
  const timeRange = useMemo(() => ({ type: "relative", from: rangeSeconds }), [rangeSeconds]);
  const entries = useMemo(
    () => buildEntries(timeRange, permittedAlertsEventsStreams, t),
    [timeRange, permittedAlertsEventsStreams, t]
  );
  return useWelcomeSearch(entries, timeRange);
};
export default useSecurityKpisSearch;
